<template>
  <div class="loadedit">
    <BlockUI message="" :html="html" v-if="loading" />
  </div>
</template>

<style>
.loading-container .loading-backdrop {
  background: #fff !important;
  opacity: 0.7 !important;
}
.dark-style .loading-container .loading-backdrop {
  background: #22252b !important;
  opacity: 0.8 !important;
}
.loading-container .loading {
  background: none !important;
  box-shadow: none !important;
}
</style>

<style src="@/vendor/libs/spinkit/spinkit.scss" lang="scss"></style>

<script>
import Vue from "vue";
import BlockUI from "vue-blockui";

Vue.use(BlockUI);

export default {
  name: "miscellaneous-vue-blockui",
  data: () => ({
    loading: false,
    html: `
<div class="sk-fold sk-primary mx-auto mb-4"><div class="sk-fold-cube"></div><div class="sk-fold-cube"></div><div class="sk-fold-cube"></div><div class="sk-fold-cube"></div></div>
<h5 class="text-center mb-0">LOADING...</h5>`,
  }),
  created() {
    // this.html =  `<div class="sk-folding-cube sk-primary"><div class="sk-cube1 sk-cube"></div><div class="sk-cube2 sk-cube"></div><div class="sk-cube4 sk-cube"></div><div class="sk-cube3 sk-cube"></div></div><h5 class="text-center mb-0">${this.$t("m.content.common.LOADING")}</h5>`
    this.html = `<div class="sk-fold sk-primary mx-auto mb-4"><div class="sk-fold-cube"></div><div class="sk-fold-cube"></div><div class="sk-fold-cube"></div><div class="sk-fold-cube"></div></div><h5 class="text-center mb-0">${this.$t(
      "m.content.common.LOADING"
    )}</h5>`;
  },
  mounted() {
    var tath = this;
    window.addEventListener("setItem", (e) => {
      if (e.key == "lastname") {
        tath.html = `<div class="sk-fold sk-primary mx-auto mb-4"><div class="sk-fold-cube"></div><div class="sk-fold-cube"></div><div class="sk-fold-cube"></div><div class="sk-fold-cube"></div></div><h5 class="text-center mb-0">${tath.$t(
          "m.content.common.LOADING"
        )}</h5>`;
      }
    });
  },
  methods: {
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    blockPage() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 4000);
    },
  },
};
</script>
